// M01 數系與近似值 - 練習題數據
// 系統化設計，整合所有子主題數據，準備 Supabase 數據遷移
// 總共 170 題，涵蓋 17 個學習主題

// 導入所有主題數據
import {
  M01_01_PROBLEMS, M01_02_PROBLEMS, M01_03_PROBLEMS, M01_04_PROBLEMS, M01_05_PROBLEMS
} from './M01_Topics_01_to_05.js';

import {
  M01_06_PROBLEMS, M01_07_PROBLEMS, M01_08_PROBLEMS, M01_09_PROBLEMS, M01_10_PROBLEMS
} from './M01_Topics_06_to_10.js';

import {
  M01_11_PROBLEMS, M01_12_PROBLEMS, M01_13_PROBLEMS, M01_14_PROBLEMS, M01_15_PROBLEMS
} from './M01_Topics_11_to_15.js';

import {
  M01_16_PROBLEMS, M01_17_PROBLEMS
} from './M01_Topics_16_to_17.js';

// ========== 主題資訊定義 ==========
export const M01_MODULE_INFO = {
  id: 'M01',
  title: 'M01 數系與近似值',
  description: '學習科學記數法、有效數字、誤差分析、進制轉換等數學基礎概念',
  totalProblems: 170,
  estimatedTime: '8-10 小時',
  difficulty: 'Basic to Intermediate',
  prerequisites: ['基本算術運算', '小數與分數概念'],
  learningObjectives: [
    '掌握科學記數法的轉換和運算',
    '理解有效數字的概念和規則',
    '學會誤差計算和分析方法',
    '熟練進行進制轉換',
    '應用數學概念解決實際問題'
  ]
};

// ========== 學習主題定義 ==========
export const M01_TOPICS = [
  {
    id: 'M01_01',
    title: '科學記數法轉換',
    description: '學習大數和小數的科學記數法表示方法',
    problemCount: 10,
    difficulty: 1,
    order: 1
  },
  {
    id: 'M01_02',
    title: '有效數字處理',
    description: '理解有效數字的概念和計算規則',
    problemCount: 10,
    difficulty: 2,
    order: 2
  },
  {
    id: 'M01_03',
    title: '科學記數法乘法',
    description: '掌握科學記數法的乘法運算技巧',
    problemCount: 10,
    difficulty: 2,
    order: 3
  },
  {
    id: 'M01_04',
    title: '誤差計算',
    description: '學習絕對誤差、相對誤差和百分誤差的計算',
    problemCount: 10,
    difficulty: 2,
    order: 4
  },
  {
    id: 'M01_05',
    title: '近似值計算',
    description: '掌握四捨五入和近似值的處理方法',
    problemCount: 10,
    difficulty: 1,
    order: 5
  },
  {
    id: 'M01_06',
    title: '百分誤差公式',
    description: '學習百分誤差的計算公式和應用',
    problemCount: 10,
    difficulty: 2,
    order: 6
  },
  {
    id: 'M01_07',
    title: '誤差界限分析',
    description: '理解誤差界限的概念和傳播規律',
    problemCount: 10,
    difficulty: 3,
    order: 7
  },
  {
    id: 'M01_08',
    title: '有效數字規則',
    description: '深入學習有效數字在各種運算中的規則',
    problemCount: 10,
    difficulty: 2,
    order: 8
  },
  {
    id: 'M01_09',
    title: '加法有效數字處理',
    description: '專門學習加減法運算中的有效數字處理',
    problemCount: 10,
    difficulty: 2,
    order: 9
  },
  {
    id: 'M01_10',
    title: '有效數字解釋',
    description: '理解有效數字的物理意義和重要性',
    problemCount: 10,
    difficulty: 2,
    order: 10
  },
  {
    id: 'M01_11',
    title: '十進制轉二進制',
    description: '學習十進制數轉換為二進制數的方法',
    problemCount: 10,
    difficulty: 2,
    order: 11
  },
  {
    id: 'M01_12',
    title: '二進制轉十進制',
    description: '學習二進制數轉換為十進制數的方法',
    problemCount: 10,
    difficulty: 2,
    order: 12
  },
  {
    id: 'M01_13',
    title: '二進制加法',
    description: '掌握二進制數的加法運算規則',
    problemCount: 10,
    difficulty: 2,
    order: 13
  },
  {
    id: 'M01_14',
    title: '進制驗證',
    description: '學習驗證進制轉換和運算結果的正確性',
    problemCount: 10,
    difficulty: 2,
    order: 14
  },
  {
    id: 'M01_15',
    title: '基本面積計算',
    description: '結合有效數字概念進行面積計算',
    problemCount: 10,
    difficulty: 2,
    order: 15
  },
  {
    id: 'M01_16',
    title: '複合誤差分析',
    description: '學習複雜計算中的誤差傳播和分析',
    problemCount: 10,
    difficulty: 3,
    order: 16
  },
  {
    id: 'M01_17',
    title: '百分誤差轉換',
    description: '掌握百分誤差與絕對誤差之間的轉換',
    problemCount: 10,
    difficulty: 2,
    order: 17
  }
];

// ========== 問題數據整合 ==========
export const M01_PROBLEMS_DATA = {
  'M01_01': M01_01_PROBLEMS,
  'M01_02': M01_02_PROBLEMS,
  'M01_03': M01_03_PROBLEMS,
  'M01_04': M01_04_PROBLEMS,
  'M01_05': M01_05_PROBLEMS,
  'M01_06': M01_06_PROBLEMS,
  'M01_07': M01_07_PROBLEMS,
  'M01_08': M01_08_PROBLEMS,
  'M01_09': M01_09_PROBLEMS,
  'M01_10': M01_10_PROBLEMS,
  'M01_11': M01_11_PROBLEMS,
  'M01_12': M01_12_PROBLEMS,
  'M01_13': M01_13_PROBLEMS,
  'M01_14': M01_14_PROBLEMS,
  'M01_15': M01_15_PROBLEMS,
  'M01_16': M01_16_PROBLEMS,
  'M01_17': M01_17_PROBLEMS
};

// ========== 數據統計和驗證 ==========
export const M01_STATISTICS = {
  totalTopics: M01_TOPICS.length,
  totalProblems: Object.values(M01_PROBLEMS_DATA).reduce((total, problems) => total + problems.length, 0),
  problemsPerTopic: 10,
  difficultyDistribution: {
    easy: Object.values(M01_PROBLEMS_DATA).flat().filter(p => p.difficulty === 1).length,
    medium: Object.values(M01_PROBLEMS_DATA).flat().filter(p => p.difficulty === 2).length,
    hard: Object.values(M01_PROBLEMS_DATA).flat().filter(p => p.difficulty === 3).length
  },
  topicsByDifficulty: {
    1: M01_TOPICS.filter(t => t.difficulty === 1).length,
    2: M01_TOPICS.filter(t => t.difficulty === 2).length,
    3: M01_TOPICS.filter(t => t.difficulty === 3).length
  }
};

// ========== 匯總所有問題數據的函數 ==========
export const getAllM01Problems = () => {
  return Object.values(M01_PROBLEMS_DATA).flat();
};

// ========== 根據主題ID獲取問題 ==========
export const getProblemsByTopicId = (topicId) => {
  return M01_PROBLEMS_DATA[topicId] || [];
};

// ========== 根據難度獲取問題 ==========
export const getProblemsByDifficulty = (difficulty) => {
  return getAllM01Problems().filter(problem => problem.difficulty === difficulty);
};

// ========== 獲取隨機問題 ==========
export const getRandomProblems = (count = 10, topicId = null) => {
  let problems;
  if (topicId) {
    problems = getProblemsByTopicId(topicId);
  } else {
    problems = getAllM01Problems();
  }
  
  // 洗牌算法
  const shuffled = [...problems].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

// ========== 數據驗證函數 ==========
export const validateM01Data = () => {
  const validation = {
    isValid: true,
    errors: [],
    warnings: []
  };

  // 檢查每個主題是否有對應的問題數據
  M01_TOPICS.forEach(topic => {
    const problems = getProblemsByTopicId(topic.id);
    if (problems.length === 0) {
      validation.errors.push(`主題 ${topic.id} 沒有問題數據`);
      validation.isValid = false;
    } else if (problems.length !== 10) {
      validation.warnings.push(`主題 ${topic.id} 的問題數量不是 10 題 (實際: ${problems.length})`);
    }
  });

  // 檢查問題ID的唯一性
  const allProblems = getAllM01Problems();
  const problemIds = allProblems.map(p => p.id);
  const uniqueIds = new Set(problemIds);
  if (problemIds.length !== uniqueIds.size) {
    validation.errors.push('存在重複的問題ID');
    validation.isValid = false;
  }

  // 檢查問題結構完整性
  allProblems.forEach((problem, index) => {
    const requiredFields = ['id', 'topicId', 'question', 'solution', 'explanation', 'hint', 'difficulty', 'order', 'steps'];
    requiredFields.forEach(field => {
      if (!problem[field]) {
        validation.errors.push(`問題 ${problem.id || index} 缺少必需字段: ${field}`);
        validation.isValid = false;
      }
    });
  });

  return validation;
};

// ========== Supabase 遷移準備 ==========
export const prepareForSupabaseImport = () => {
  const allProblems = getAllM01Problems();
  
  return {
    module: M01_MODULE_INFO,
    topics: M01_TOPICS,
    problems: allProblems.map(problem => ({
      ...problem,
      moduleId: 'M01',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      isActive: true,
      tags: generateProblemTags(problem)
    })),
    statistics: M01_STATISTICS,
    validation: validateM01Data()
  };
};

// ========== 生成問題標籤 ==========
const generateProblemTags = (problem) => {
  const tags = [];
  
  // 根據難度添加標籤
  switch(problem.difficulty) {
    case 1: tags.push('基礎', 'easy'); break;
    case 2: tags.push('中級', 'medium'); break;
    case 3: tags.push('進階', 'hard'); break;
  }
  
  // 根據主題添加標籤
  const topicMap = {
    'M01_01': ['科學記數法', '轉換'],
    'M01_02': ['有效數字', '精度'],
    'M01_03': ['科學記數法', '乘法'],
    'M01_04': ['誤差', '計算'],
    'M01_05': ['近似值', '四捨五入'],
    'M01_06': ['百分誤差', '公式'],
    'M01_07': ['誤差界限', '分析'],
    'M01_08': ['有效數字', '規則'],
    'M01_09': ['有效數字', '加法'],
    'M01_10': ['有效數字', '概念'],
    'M01_11': ['進制轉換', '十進制', '二進制'],
    'M01_12': ['進制轉換', '二進制', '十進制'],
    'M01_13': ['二進制', '加法'],
    'M01_14': ['進制', '驗證'],
    'M01_15': ['面積計算', '應用'],
    'M01_16': ['複合誤差', '分析'],
    'M01_17': ['百分誤差', '轉換']
  };
  
  if (topicMap[problem.topicId]) {
    tags.push(...topicMap[problem.topicId]);
  }
  
  return tags;
}; 